export default "__VITE_ASSET__Dix$flXb__"